import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

// Wordmark fallback for the logotype. Drop /public/brand/logo.png in and swap the <img> in
// when the Drive asset is available. Logotype rules (brand_dna.md): never recolor/stretch the PNG.
export function Logo({
  className,
  white = false,
}: {
  className?: string;
  white?: boolean;
}) {
  return (
    <Link to="/" className={cn("inline-flex flex-col leading-none", className)}>
      <span className="font-condensed text-2xl font-bold tracking-tight">
        <span className={white ? "text-white" : "text-night-blue"}>Dr</span>
        {/*
          DRB-66 — these two keep the raw brand tokens on purpose. axe flags them at 2.28:1 and
          2.57:1, but WCAG 1.4.3 exempts logotypes outright: "text that is part of a logo or brand
          name has no contrast requirement". axe cannot tell a wordmark from body copy. Recolouring
          her brand mark to satisfy a false positive would be changing her identity to make a tool
          quiet — everywhere these colours carry actual CONTENT, they now use the -ink siblings.
        */}
        <span className="text-leaf-green">Burns</span>
        <span className={white ? "text-white" : "text-night-blue"}>
          {String.fromCharCode(39)}{" "}
        </span>
        <span className="text-healthy-blue">ReLeaf</span>
      </span>
      <span
        className={cn(
          "font-condensed text-[10px] uppercase tracking-[0.2em]",
          white ? "text-white/70" : "text-night-blue/70",
        )}
      >
        Rooted in Science
      </span>
    </Link>
  );
}
